import React, { Component } from 'react';
import { Layout } from 'antd';

export default class Content extends Component {

    render() {
        return (
            <Layout className={'fill vscroll ' + this.props.className || " "}>
                {this.props.children}
            </Layout>
        );
    }
}